<template>
  <a-modal v-model="myShow" @cancel="allClose" width="1000px" :title="title">
    <section class="form-box">
      <FormStep :current="current"></FormStep>
      <section class="content">
        <FormPlan
          ref="formPlan"
          :obj="obj"
          v-show="showFormPlan"
          @showView="hshowView"
        ></FormPlan>
        <DetailList
          v-show="showView"
          :template-no="viewCode || '42852754ba064ff58d6425d33fa599aa'"
          @close="() => (showView = false)"
          @submit="onSubmit"
          :check_list="obj?.check_list || []"
        ></DetailList>
      </section>

      <div class="daily-print-container">
        <div id="dailyPrint">
          <PrintDetailList
            :key="printKey"
            v-if="obj"
            style="width: 100%"
            :task="obj"
            :template-no="viewCode || '42852754ba064ff58d6425d33fa599aa'"
            :check_list="obj?.check_list || []"
          />
        </div>
      </div>
    </section>
    <template #footer>
      <a-button
        v-if="myLink === Links.Plan"
        key="submit"
        type="primary"
        @click="nextCheck"
        >执行</a-button
      >
      <a-button v-if="!!id" key="print" type="primary" v-print="printOptions"
        >打印</a-button
      >
      <a-button key="close" @click="allClose">关闭</a-button>
    </template>
    <a-modal
      v-model="formCheckState.show"
      width="800px"
      title="每日食品安全检查记录"
      @ok="jlSubmit"
    >
      <FormCheck ref="formCheck" :data="planFormData"></FormCheck>
      <template #footer>
        <LazyButton type="primary" @click="jlSubmit">确定</LazyButton>
      </template>
    </a-modal>
  </a-modal>
</template>
<script setup>
import { ref, computed, provide, getCurrentInstance, watch } from "vue";
import FormStep from "./form-step.vue";
import FormPlan from "./form-plan.vue";
import DetailList from "./detail-list.vue";
import PrintDetailList from "./print-detail-list.vue";
import { Links } from "../data/template";
import { getAddForm } from "../methods/getAddForm";
import FormCheck from "./form-check.vue";
import { message } from "ant-design-vue";
import { dailyControlAdd } from "@/api/control";
import { LazyButton } from "@/components/LazyButton";

// 提供 store 以便子组件使用
const instance = getCurrentInstance();
provide('$store', instance?.proxy?.$store);

const props = defineProps({
  id: {
    default: "",
  },
  link: {
    type: String,
    default: Links.Plan,
  },
  show: {
    type: Boolean,
    default: false,
  },
  obj: {
    type: Object,
    default: () => ({}),
  },
});
const printOptions = {
  id: "dailyPrint",
  popTitle: "正常打印",
  extraHead: "",
};

// 打印组件强制刷新逻辑
const printKey = ref(0);
const forceRefreshPrint = () => {
  printKey.value++;
};
provide('forceRefreshPrint', forceRefreshPrint);

// 监听 check_list 变化，强制刷新打印组件
watch(
  () => props.obj?.check_list,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      forceRefreshPrint();
    }
  },
  { deep: true }
);

const formCheck = ref();
const emits = defineEmits(["success", "update:show"]);

const myShow = computed({
  get() {
    return props.show;
  },
  set(val) {
    emits("update:show", val);
  },
});

const allClose = () => {
  formCheckState.show = false;
  myShow.value = false;
  if (myLink.value === Links.Rectification) {
    emits("success");
  }
};

const {
  title,
  showFormPlan,
  showView,
  viewCode,
  hshowView,
  current,
  nextCheck,
  myLink,
  formPlan,
  planFormData,
  onSubmit,
  formCheckState,
} = getAddForm(props);

// (props);
/**真正提交 */
async function jlSubmit() {
  const checkForm = formCheck.value.getFormData();
  const obj = {
    ...checkForm,
    ...planFormData.value,
  };
  await dailyControlAdd(obj);
  message.success("提交成功"), message.success("本次检查已完成");
  formCheckState.show = false;
  myShow.value = false;
  emits("success");
}
</script>
<style lang="less" scoped>
.form-box {
  height: 600px;
  padding: 16px;
}
.content {
  margin-top: 20px;
  height: 90%;
  overflow: auto;
}


.daily-print-container {
  position: fixed;
  left: -10000px;
  top: 0;
  z-index: -9999;
  width: 790px; /* 调整为接近A4纸的宽度，避免过宽导致打印内容被截断或缩小 */
  height: auto;
  overflow: visible;
  visibility: visible;
  display: block;
  background: white;
}

// /* 仅在打印时显示 */
// @media print {
//   .daily-print-container {
//     position: static !important;
//     width: auto !important;
//     height: auto !important;
//     overflow: visible !important;
//     visibility: visible !important;
//     display: block !important;
//   }
// }
@page {
  // size: auto;
  // margin: 3mm;
}
</style>
